<script setup lang="ts">
import { Plus, Trash } from "@iconoir/vue";
import type { CanvassTargetWithProgress } from "./types";
import { useCanvassTargets } from "./useCanvassTargets";

const canvassTargets = defineModel<Array<CanvassTargetWithProgress>>(
  "canvassTargets",
  {
    required: true,
  },
);

const { createCanvassTarget, deleteCanvassTarget } =
  useCanvassTargets(canvassTargets);
</script>

<template>
  <div class="canvass-targets-form">
    <span>Gesprächsziele</span>
    <span class="target-column">Anzahl</span>
    <template
      v-for="(canvassTarget, index) in canvassTargets"
      :key="canvassTarget.id"
    >
      <div>
        <label
          class="visually-hidden"
          :for="`canvass-target-description-${index}`"
          >Gesprächsziel {{ index + 1 }}: Beschreibung</label
        ><input
          :id="`canvass-target-description-${index}`"
          v-model="canvassTarget.description"
          type="text"
          required
        />
      </div>
      <div>
        <label class="visually-hidden" :for="`canvass-target-target-${index}`">
          Gesprächsziel {{ index + 1 }}: Anzahl</label
        ><input
          :id="`canvass-target-target-${index}`"
          v-model="canvassTarget.target"
          type="number"
          required
          min="0"
        />
      </div>
      <button
        class="button button--tertiary"
        type="button"
        @click.prevent="deleteCanvassTarget(canvassTarget)"
      >
        <Trash />
        <span class="visually-hidden"> Gesprächsziel löschen </span>
      </button>
    </template>
    <button
      class="button button--secondary"
      type="button"
      @click.prevent="createCanvassTarget()"
    >
      <Plus />
      <span class="visually-hidden"> Neues Gesprächsziel erstellen </span>
    </button>
  </div>
</template>

<style scoped>
.canvass-targets-form {
  display: grid;
  grid-template-columns: 3fr 1fr auto;
  gap: var(--spacing-xs);
}

.target-column {
  grid-column: 2 / 4;
}

input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
